import { render, staticRenderFns } from "./AmeAboutYou.vue?vue&type=template&id=7d5a4ada&scoped=true"
import script from "./AmeAboutYou.vue?vue&type=script&lang=js"
export * from "./AmeAboutYou.vue?vue&type=script&lang=js"
import style0 from "./AmeAboutYou.vue?vue&type=style&index=0&id=7d5a4ada&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7d5a4ada",
  null
  
)

export default component.exports